import { downloadBlob } from "@/utils/downloadBlob";

export const TABLE_ID_MAPPING_MAX_BYTES = 1024 * 1024;

export const DEFAULT_TABLE_ID_MAPPING_FILE_NAME = "table-id-mapping.csv";

export const TABLE_ID_MAPPING_TEMPLATE_FILE_NAME =
  "table-id-mapping-template.csv";

const GENERIC_DOWNLOAD_NAMES = new Set(["download", "download.csv"]);

export function resolveTableIdMappingFileName(
  ...candidates: Array<string | null | undefined>
): string {
  for (const candidate of candidates) {
    const name = candidate?.trim();
    if (!name || GENERIC_DOWNLOAD_NAMES.has(name.toLowerCase())) {
      continue;
    }
    return name.toLowerCase().endsWith(".csv") ? name : `${name}.csv`;
  }
  return DEFAULT_TABLE_ID_MAPPING_FILE_NAME;
}

export const TABLE_ID_MAPPING_TEMPLATE_CSV =
  "Table number,QR url,POS table ID\n";

export function downloadTableIdMappingTemplate(): void {
  downloadBlob(
    new Blob([TABLE_ID_MAPPING_TEMPLATE_CSV], {
      type: "text/csv;charset=utf-8;",
    }),
    TABLE_ID_MAPPING_TEMPLATE_FILE_NAME
  );
}
